define('v3/Common/Components/SubjectsDropdown/Services/subjectService',[
	'lodash',
	'v3/Common/Services/Backend/subjectBackend',
	'v3/FromV2/localStorageV3Service'
], function (_, subjectBackend, cookieService) {
	return {
		getSubjectsWhereEducationPlanExistsForClass: _.memoize(function () {
			return subjectBackend.getSubjectsWhereEducationPlanExistsForClass();
		}),

		getSubjectsAvailableForClass: function () {
			return subjectBackend.getSubjectsAvailableForClass();
		},

		saveSubjectId: function (subjectId) {
			cookieService.setSubjectFilterStateLocalStorage({ subjectIdFilter: subjectId });
		},

		getSubjectId: function () {
			var subjectFilterState = cookieService.getSubjectFilterStateLocalStorage();
			if (subjectFilterState) {
				return subjectFilterState.subjectIdFilter;
			}
			return null;
		}
	};
});
